var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17917 13.3153C6.53108 14.0088 8.08623 14.1966 9.56438 13.845C11.0425 13.4933 12.3465 12.6253 13.2412 11.3973C14.136 10.1693 14.5628 8.66205 14.4446 7.14725C14.3264 5.63244 13.6711 4.20965 12.5967 3.13527C11.5223 2.06089 10.0995 1.40556 8.58472 1.28739C7.06991 1.16921 5.56271 1.59596 4.33471 2.49072C3.1067 3.38549 2.23866 4.68944 1.88699 6.16759C1.53533 7.64574 1.72317 9.20089 2.41667 10.5528L1 14.732L5.17917 13.3153Z",
    stroke: "#9E9E9F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/CommentIcon.90aad006859ac687d5fd1abe1a2aa74a.svg";
export { ForwardRef as ReactComponent };